import { render, staticRenderFns } from "./StatsDBKS.vue?vue&type=template&id=2a99bebe&scoped=true&"
import script from "./StatsDBKS.vue?vue&type=script&lang=js&"
export * from "./StatsDBKS.vue?vue&type=script&lang=js&"
import style0 from "./StatsDBKS.vue?vue&type=style&index=0&id=2a99bebe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a99bebe",
  null
  
)

export default component.exports